import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActiveUser } from 'top-context';
import { UserState } from './user.type';

export const initialState: UserState = {};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setActiveUser: (state, { payload }: PayloadAction<ActiveUser>) => {
      state.activeUser = payload;
    },
  },
});

export const userReducer = userSlice.reducer;
export const userActions = userSlice.actions;
